import specificat from '@/api/product/specification'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
	...baseState,
  productSalecodes: []
}

export const getters = {}

export const mutations = {
	...baseMutations,
  SET_PRODUCT_SALECODE(state, data){
    state.productSalecodes = data
  },
	CLEAR_SETUP(state){
		state.productSalecodes = []
	}
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return specificat.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return specificat.store(data)
  },
  find(context, id) {
    return specificat.find(id)
  },
  update(context, { id, data }) {
    return specificat.update(id, data)
  },
  async fetResource(context) {
    let response = await specificat.saleCode()
    context.commit('SET_PRODUCT_SALECODE', response.data)
  }
}